import { createFileRoute, redirect } from '@tanstack/react-router'
import { BillFormScreen } from '@/features/accounting-bills/bill-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating a bill.
 *
 * The grant guard is presentation only. The API enforces
 * `accounting_bill.create` on POST /accounting/bills, so a stale grant still
 * 403s server-side; this keeps a user without it out of a screen they cannot
 * use.
 */
export const Route = createFileRoute('/_authenticated/accounting/bills/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bill.create')) {
      throw redirect({ to: '/accounting/bills' })
    }
  },
  component: BillFormScreen,
})
